module.exports = __webpack_public_path__ + "img/B3.e2e05cce.svg";